/*
 * @Desc: 项目核心文件
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-09 11:04:34
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
 */
import Vue from 'vue';
import router from './router/index';
// import VueAxios from 'vue-axios'
import utils from "@/api/Utils.js"

import Cookies from "js-cookie";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI,{
  size: 'mini' // set element-ui default size
});

// 各API接口
import api from './api/api'; // 导入api接口
// 首页模板
import App from './App.vue';
// 状态管理
import store from './vuex/store';

// 全局参数
const publicData = {
  imgUrl:'http://hengyuanadmin.137idea.com'
};

if (location.origin.indexOf('localhost') != -1 || location.origin.indexOf('schoolgw.shanmuzhi.com') != -1){
	publicData.imgUrl = 'http://schoolinfo.shanmuzhi.com'
}

Vue.prototype.$publicData = publicData;
Vue.prototype.Cookies = Cookies;

// 图片拼接前缀
Vue.prototype.$adddom = function (src) {
  if (src == "" || src == undefined || src == null) {
      // console.log("src地址有问题");
      return "";
  }
  if (src.substr(0, 4).toLowerCase() === "http") {
      return src;
  }
  return this.$publicData.imgUrl + src;
}
// 时间格式化
Vue.prototype.$timestampToTime = function (timestamp, type) {
  if (timestamp == "" || timestamp == undefined || timestamp == null) {
      // console.log("src地址有问题");
      return "";
  }
  return utils.timestampToTime(timestamp, type)
}
// 路由跳转
Vue.prototype.$toPath = function (url, obj) {
  if (this.$route.fullPath == url) {
      return;
  }
  // if (this.$route.path == url) {
  //     this.$router.push({
  //         path: url,
  //         query: obj
  //     });
  //     window.location.reload();
  //     return;
  // }
  this.$router.push({
      path: url,
      query: obj
  });
}

Vue.config.productionTip = false;
Vue.prototype.$api = api; // 将api挂载到vue的原型上
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
